"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _FormControlContext = _interopRequireWildcard(require("../FormControl/FormControlContext"));
var _formControlState = _interopRequireDefault(require("../FormControl/formControlState"));
var _tss = require("../styles/tss");
var _Text = _interopRequireDefault(require("../Text"));
const _excluded = ["children", "classes", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _tss.makeTssStyles)({
  name: 'DsInputAdornment',
  uniqId: 'E9CSIn'
})((theme, _params, classes) => ({
  root: {
    display: 'flex',
    height: '0.01em',
    // Fix IE11 flexbox alignment. To remove at some point.
    maxHeight: '2em',
    alignItems: 'center',
    whiteSpace: 'nowrap'
  },
  filled: {
    [`&.${classes.positionStart}`]: {
      marginTop: theme.busbud.spacing(2)
    }
  },
  positionStart: {
    marginRight: theme.busbud.spacing(1)
  },
  positionEnd: {
    marginLeft: theme.busbud.spacing(1)
  },
  disablePointerEvents: {
    pointerEvents: 'none'
  }
}));
/**
 **❗️ DEPRECATED**
 *
 * This can be used to add a prefix, a suffix or an action to an input. For instance, you can use an icon button to hide or reveal the password.
 *
 * @deprecated
 */
const InputAdornment = /*#__PURE__*/React.forwardRef(function InputAdornment(props, ref) {
  const {
      children,
      classes: classesOverrides,
      className,
      component: Component = 'div',
      disablePointerEvents = false,
      disableTypography = false,
      position,
      variant: variantProp
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const {
    cx,
    classes
  } = useStyles(undefined, {
    props: {
      classes: classesOverrides
    }
  });
  const dsFormControl = (0, _FormControlContext.useFormControl)() || {};
  const fcs = (0, _formControlState.default)({
    props,
    dsFormControl,
    states: ['filled']
  });
  let variant = variantProp;
  if (variantProp && dsFormControl.variant) {
    if (process.env.NODE_ENV !== 'production') {
      if (variantProp === dsFormControl.variant) {
        console.error('DSCL: The `InputAdornment` variant infers the variant prop ' + 'you do not have to provide one.');
      }
    }
  }
  if (dsFormControl && !variant) {
    variant = dsFormControl.variant;
  }
  return /*#__PURE__*/React.createElement(_FormControlContext.default.Provider, {
    value: fcs
  }, /*#__PURE__*/React.createElement(Component
  // @ts-ignore TS2590
  , (0, _extends2.default)({
    className: cx(classes.root, {
      [classes.filled]: variant === 'filled',
      [classes.positionStart]: position === 'start',
      [classes.positionEnd]: position === 'end',
      [classes.disablePointerEvents]: disablePointerEvents
    }, className),
    ref: ref
  }, other), typeof children === 'string' && !disableTypography ? /*#__PURE__*/React.createElement(_Text.default, null, children) : children));
});
var _default = exports.default = InputAdornment;